import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["newUserFields", "existingUserFields", "existingUserId", "userSearchResults"]
  static values = { salespersonUrl: String }

  connect() {
    this.toggleUserFields()
  }

  toggleUserFields() {
    const isNew = this.element.querySelector('input[name="user_option"][value="new"]')?.checked
    if (isNew === undefined) return

    if (isNew) {
      if (this.hasNewUserFieldsTarget) {
        this.newUserFieldsTarget.classList.remove("hidden")
        this.newUserFieldsTarget.querySelectorAll("input[required]").forEach(i => { i.required = true })
      }
      if (this.hasExistingUserFieldsTarget) {
        this.existingUserFieldsTarget.classList.add("hidden")
        if (this.hasExistingUserIdTarget) this.existingUserIdTarget.required = false
      }
    } else {
      if (this.hasNewUserFieldsTarget) {
        this.newUserFieldsTarget.classList.add("hidden")
        this.newUserFieldsTarget.querySelectorAll("input[required]").forEach(i => { i.required = false })
      }
      if (this.hasExistingUserFieldsTarget) {
        this.existingUserFieldsTarget.classList.remove("hidden")
        if (this.hasExistingUserIdTarget) this.existingUserIdTarget.required = true
      }
    }
  }

  searchUsers(event) {
    const query = event.target.value.trim()
    if (query.length < 2) {
      if (this.hasUserSearchResultsTarget) this.userSearchResultsTarget.classList.add("hidden")
      return
    }
    if (this.hasUserSearchResultsTarget) {
      this.userSearchResultsTarget.innerHTML = '<div class="p-3 text-sm text-gray-500">Start typing to search for users...</div>'
      this.userSearchResultsTarget.classList.remove("hidden")
    }
  }

  openSalespersonModal() {
    fetch(this.salespersonUrlValue + ".json", {
      method: "GET",
      headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json" }
    })
    .then(response => response.json())
    .then(data => { document.body.insertAdjacentHTML("beforeend", data.html) })
    .catch(() => alert("Error loading form. Please try again."))
  }
}
